// API Configuration
export const API_CONFIG = {
  // In development, use proxy to avoid CORS issues
  // In production, use the full URL from environment variable
  BASE_URL: import.meta.env.VITE_API_URL || (import.meta.env.DEV ? '/api' : 'https://dev.iqarx.com/api/v0'),
  WEBSOCKET_URL: import.meta.env.VITE_WS_URL || 'ws://localhost:8000/ws',
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
};

// Video Configuration
export const VIDEO_CONFIG = {
  WIDTH: 1280,
  HEIGHT: 720,
  FRAME_RATE: 30,
  MIME_TYPE: 'video/webm;codecs=vp9',
  FALLBACK_MIME_TYPE: 'video/webm',
  CHUNK_INTERVAL: 10000, // Record in 10-second intervals (matches reference implementation)
  MAX_RECORDING_TIME: 60 * 60 * 1000, // 1 hour max
};

// Audio Configuration
export const AUDIO_CONFIG = {
  SAMPLE_RATE: 48000,
  CHANNEL_COUNT: 1,
  ECHO_CANCELLATION: true,
  NOISE_SUPPRESSION: true,
  AUTO_GAIN_CONTROL: true,
};

// Interview Configuration
export const INTERVIEW_CONFIG = {
  MAX_DURATION: 60 * 60 * 1000, // 1 hour
  WARNING_TIME: 5 * 60 * 1000, // 5 minutes before end
  IDLE_TIMEOUT: 5 * 60 * 1000, // 5 minutes of inactivity
  RECONNECT_TIMEOUT: 30000, // 30 seconds to reconnect
};

// Error Messages - English
export const ERROR_MESSAGES_EN = {
  CAMERA_PERMISSION_DENIED: 'Camera access denied. Please allow camera access to continue.',
  MICROPHONE_PERMISSION_DENIED: 'Microphone access denied. Please allow microphone access to continue.',
  CAMERA_NOT_FOUND: 'No camera found. Please connect a camera and try again.',
  MICROPHONE_NOT_FOUND: 'No microphone found. Please connect a microphone and try again.',
  NETWORK_ERROR: 'Network connection lost. Please check your internet connection.',
  NETWORK_SLOW: 'Your connection is slow. Video quality may be affected.',
  SERVER_ERROR: 'Server error occurred. Please try again later.',
  SESSION_EXPIRED: 'Your session has expired. Please login again.',
  RECORDING_ERROR: 'Failed to start recording. Please refresh and try again.',
  INVALID_CREDENTIALS: 'Invalid email or access code. Please try again.',
  TIMEOUT_ERROR: 'Connection timed out. Please try again.',
  UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
  BROWSER_NOT_SUPPORTED: 'Your browser does not support video recording. Please use Chrome, Firefox, or Edge.',
};

// Error Messages - Arabic
export const ERROR_MESSAGES_AR = {
  CAMERA_PERMISSION_DENIED: 'تم رفض الوصول للكاميرا. يرجى السماح بالوصول للمتابعة.',
  MICROPHONE_PERMISSION_DENIED: 'تم رفض الوصول للميكروفون. يرجى السماح بالوصول للمتابعة.',
  CAMERA_NOT_FOUND: 'لم يتم العثور على كاميرا. يرجى توصيل كاميرا والمحاولة مرة أخرى.',
  MICROPHONE_NOT_FOUND: 'لم يتم العثور على ميكروفون. يرجى توصيل ميكروفون والمحاولة مرة أخرى.',
  NETWORK_ERROR: 'انقطع الاتصال بالإنترنت. يرجى التحقق من اتصالك.',
  NETWORK_SLOW: 'اتصالك بطيء. قد تتأثر جودة الفيديو.',
  SERVER_ERROR: 'حدث خطأ في الخادم. يرجى المحاولة لاحقاً.',
  SESSION_EXPIRED: 'انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.',
  RECORDING_ERROR: 'فشل بدء التسجيل. يرجى تحديث الصفحة والمحاولة مرة أخرى.',
  INVALID_CREDENTIALS: 'البريد الإلكتروني أو رمز الدخول غير صحيح.',
  TIMEOUT_ERROR: 'انتهت مهلة الاتصال. يرجى المحاولة مرة أخرى.',
  UNKNOWN_ERROR: 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
  BROWSER_NOT_SUPPORTED: 'متصفحك لا يدعم تسجيل الفيديو. يرجى استخدام Chrome أو Firefox أو Edge.',
};

// Interview Phases
export const INTERVIEW_PHASES = {
  LOGIN: 'login',
  PROCEED: 'proceed',
  CAMERA_CHECK: 'camera_check',
  LIVE_PREVIEW: 'live_preview',
  INTERVIEW: 'interview',
  COMPLETED: 'completed',
  ERROR: 'error',
};

// Connection States
export const CONNECTION_STATES = {
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  DISCONNECTED: 'disconnected',
  ERROR: 'error',
};

// Media States
export const MEDIA_STATES = {
  IDLE: 'idle',
  REQUESTING: 'requesting',
  ACTIVE: 'active',
  ERROR: 'error',
  DENIED: 'denied',
};

// Languages
export const LANGUAGES = {
  EN: 'en',
  AR: 'ar',
};

// Routes
export const ROUTES = {
  LOGIN: '/',
  PROCEED: '/proceed',
  CAMERA_CHECK: '/camera-check',
  LIVE_PREVIEW: '/live-preview',
  INTERVIEW: '/interview',
  COMPLETED: '/completed',
};

// Storage Keys (sessionStorage for auth, localStorage for preferences)
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'ai_interview_token',
  SESSION_ID: 'ai_interview_session',
  LANGUAGE: 'ai_interview_lang',
  USER_DATA: 'ai_interview_user',
  CURRENT_PHASE: 'ai_interview_phase',
  ACTIVE_ROOM: 'ai_interview_room', // Room name for reconnection on refresh
};
